"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMagicLink = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
function useMagicLink(resource) {
    const { startMagicLinkFlow, cancelMagicLinkFlow } = react_1.default.useMemo(() => resource.createMagicLinkFlow(), [resource]);
    react_1.default.useEffect(() => {
        return cancelMagicLinkFlow;
    }, []);
    return {
        startMagicLinkFlow,
        cancelMagicLinkFlow,
    };
}
exports.useMagicLink = useMagicLink;
//# sourceMappingURL=useMagicLink.js.map